import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { Layout } from './components/Layout';
import './custom.css';

export default class App extends Component {
  static displayName = App.name;

  constructor(props) {
    super(props);
    this.state = { frontendConfigLoaded: false };
  }

  componentDidMount() {
    fetch('/cpasrv/api/frontend_config')
      .then(r => r.json())
      .then(j => {
        if (j.error === 'none') {
          window.__FRONTEND_CONFIG = j;
        } else {
          window.__FRONTEND_CONFIG = {};
        }
        this.setState({ frontendConfigLoaded: true });
      })
      .catch(() => {
        window.__FRONTEND_CONFIG = {};
        this.setState({ frontendConfigLoaded: true });
      });
  }

  render() {
    return (
      <Layout>
        {/* Optionally gate routes until config loaded; if not needed remove the check */}
        <Routes>
          {AppRoutes.map((route, index) => {
            const { element, ...rest } = route;
            return <Route key={index} {...rest} element={element} />;
          })}
        </Routes>
      </Layout>
    );
  }
}
